import api from "../services/api";
const path = "vendedor";

export const getSellers = async () => {
  return await api.get(`${path}`);
};
